export function exception_footer_actions(blueprint, exception_action) {
  const footer_actions = blueprint.footer_actions || [exception_action('Evidence'), exception_action('View details', 'primary')];
  return footer_actions;
}

export function exception_blueprint(row, drawer_blueprints) {
  const blueprint = Reflect.get(drawer_blueprints, row?.ref) || {};
  return blueprint;
}

function value_or_default(value, fallback_value) {
  const resolved_value = value || fallback_value;
  return resolved_value;
}

function exception_drawer_defaults(row, blueprint) {
  const defaults = {
    kicker: value_or_default(blueprint.kicker, `Exception - ${row.ref}`),
    subtitle: value_or_default(blueprint.subtitle, row.type),
    reason: value_or_default(blueprint.reason, 'Reason not captured'),
    approver: value_or_default(blueprint.approver, row.approved_by),
    expiry: value_or_default(blueprint.expiry, ''),
    status_note: value_or_default(blueprint.status_note, row.status),
    checks_alert: value_or_default(blueprint.checks_alert, ''),
    checks: value_or_default(blueprint.checks, []),
    connected_records: value_or_default(blueprint.connected_records, []),
    recommendation: value_or_default(blueprint.recommendation, '')
  };
  return defaults;
}

export function build_exception_drawer(row, drawer_blueprints, exception_action) {
  if (!row) return null;
  const blueprint = exception_blueprint(row, drawer_blueprints);
  const defaults = exception_drawer_defaults(row, blueprint);
  const exception_drawer = {
    ref: row.ref,
    title: row.exception,
    kicker: defaults.kicker,
    subtitle: defaults.subtitle,
    type: row.type,
    reason: defaults.reason,
    value: row.value,
    approver: defaults.approver,
    expiry: defaults.expiry,
    status: row.status,
    status_class: row.status_class,
    status_note: defaults.status_note,
    checks_alert: defaults.checks_alert,
    checks: defaults.checks,
    connected_records: defaults.connected_records,
    recommendation: defaults.recommendation,
    footer_actions: exception_footer_actions(blueprint, exception_action)
  };
  return exception_drawer;
}
